import { Box, Button, Flex, Icon, useBreakpointValue } from '@chakra-ui/react';
import { FC, useRef } from 'react';
import SwiperCore from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css';

import LeftIcon from '@/assets/icons/ic-left.svg';
import RightIcon from '@/assets/icons/ic-right.svg';

import { MaterialsCard } from '@/components/ui/features/originals/MaterialsSection/MaterialsCard';
import { OriginalsMaterial } from '@/resources/OriginalsMaterial';

interface IMaterialsCarouselProps {
  materials: Array<OriginalsMaterial>;
}

export const Carousel: FC<IMaterialsCarouselProps> = ({ materials }) => {
  const slidesPerView = useBreakpointValue({ base: 1, md: 2 }, { ssr: true });
  const swiperRef = useRef<SwiperCore>();

  const widthMd = materials.length === 1 ? '288px' : '600px';

  if (!slidesPerView) return null;

  const shouldShowArrows = slidesPerView < materials.length;

  return (
    <Flex mb={6} alignItems="center">
      {shouldShowArrows && (
        <Button
          variant="unstyled"
          leftIcon={<Icon color="black" w="32px" h="32px" as={LeftIcon} />}
          onClick={() => swiperRef.current?.slidePrev()}
        />
      )}
      <Box w={{ base: '240px', md: widthMd }}>
        <Swiper
          loop={shouldShowArrows}
          spaceBetween={10}
          slidesPerView={slidesPerView}
          onBeforeInit={(swiper) => {
            swiperRef.current = swiper;
          }}
        >
          {materials.map((m) => (
            <SwiperSlide key={m.id}>
              <MaterialsCard material={m} />
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
      {shouldShowArrows && (
        <Button
          variant="unstyled"
          rightIcon={<Icon color="black" w="32px" h="32px" as={RightIcon} />}
          onClick={() => swiperRef.current?.slideNext()}
        />
      )}
    </Flex>
  );
};
